import React from 'react';

import Typography from '../../library/typography/typography';
import SearchButton, {
  SearchButtonGroup
} from '../search-button/search-button';

import { useFitment } from '../../shared/hooks/hooks';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { getVehicleDataLayerValues } from '../../shared/utils/fitment/fitment';

import './choose-package-flow.scss';

function ChoosePackageFlow() {
  const { selectedFitment } = useFitment();

  return (
    <div styleName="container">
      <SearchButtonGroup>
        <SearchButton
          href="#/package/choose-tire-prebuilt-entry"
          label="Prebuilt"
          onClick={() =>
            trackAction('shop_package_prebuilt', {
              ...getVehicleDataLayerValues(selectedFitment)
            })
          }
          styleName="search-button"
        >
          <img
            alt="Choose Prebuilt"
            src="https://discounttire.scene7.com/is/image/discounttire/fitment-pre-built-tire-packages-option?$FitmentCTA$"
          />
        </SearchButton>
        <Typography styleName="or-text" variant="H6" weight="black">
          OR
        </Typography>
        <SearchButton
          href="#/package/build"
          label="Build your own"
          styleName="search-button"
        >
          <img
            alt="Choose Build your own"
            src="https://discounttire.scene7.com/is/image/discounttire/fitment-build-your-own-package-option?$FitmentCTA$"
          />
        </SearchButton>
      </SearchButtonGroup>
    </div>
  );
}

export default ChoosePackageFlow;
